import { Role, ChangeMemberRole, DeleteMemberRole } from '@/modules/acl/types'
import { useAxiosModule } from '@/modules/_shared/axios'
const { getFromApi, putToApi, deleteInApi } = useAxiosModule()

export type GetRolesResponse = Role[]
export async function getRoles () {
    return getFromApi<GetRolesResponse>('acl/roles')
}

/* Update member role */
export type UpdateMemberRoleRequest = ChangeMemberRole
export async function updateSingleMemberRole (memberId: string, req: UpdateMemberRoleRequest) {
    return putToApi<null>(`acl/members/${memberId}/roles`, req)
}

/* Delete member role */
export type DeleteMemberRoleRequest = DeleteMemberRole
export async function deleteSingleMemberRole (memberId: string, req: DeleteMemberRoleRequest) {
    return deleteInApi<null>(`acl/members/${memberId}/roles`, req)
}
